import { CRMConfigurationPage } from '@/account/api/types';

export const objectTypeTitleMap: Record<CRMConfigurationPage, string> = {
  PIPELINE: 'Pipeline selection',
  PROJECT: 'Project mapping',
  COMPANY: 'Customer mapping',
  PRODUCT: 'Line item mapping',
};

export const objectTypeSubTitleMap: Record<CRMConfigurationPage, string> = {
  PIPELINE:
    'Sync your HubSpot deal data into a new Hardfin project automatically\n' +
    '            when deals reach a certain stage',
  PROJECT: 'Map your Hardfin projects from your HubSpot deals',
  COMPANY: 'Map your Hardfin customers from your HubSpot companies',
  PRODUCT: 'Map your Hardfin line items from your HubSpot line items',
};

export const objectTypeLabelMap: Record<CRMConfigurationPage, string> = {
  PIPELINE: 'Pipeline',
  PROJECT: 'Project',
  COMPANY: 'Customer',
  PRODUCT: 'Project line item',
};
